// LEGACY — superseded by features/client-meetings/ (TanStack Query). Scheduled for deletion in 2 sprints.
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// TODO: Import real API services when available
// import { getAllClientMeetings, getClientMeetingById, createClientMeeting, updateClientMeeting, deleteClientMeeting } from "../../services/clientMeetingService";

export const getMeetings = createAsyncThunk(
  "meetings/getMeetings",
  async () => {
    try {
      // TODO: Replace with real API call
      toast.error("Meetings API not yet implemented", { autoClose: 3000 });
      return { items: [], pageNumber: 1, pageSize: 20, totalCount: 0, totalPages: 0, hasPreviousPage: false, hasNextPage: false };
    } catch (error) {
      return error;
    }
  }
);

export const getMeetingById = createAsyncThunk(
  "meetings/getMeetingById",
  async (id: number) => {
    try {
      // TODO: Replace with real API call
      toast.error("Meeting API not yet implemented", { autoClose: 3000 });
      throw new Error("Meeting API not yet implemented");
    } catch (error) {
      return error;
    }
  }
);

export const addNewMeeting = createAsyncThunk(
  "meetings/addNewMeeting",
  async (meeting: any) => {
    try {
      // TODO: Replace with real API call
      toast.error("Meeting creation API not yet implemented", { autoClose: 3000 });
      throw new Error("Meeting creation API not yet implemented");
    } catch (error) {
      toast.error("Meeting Schedule Failed", { autoClose: 3000 });
      return error;
    }
  }
);

export const updateMeeting = createAsyncThunk(
  "meetings/updateMeeting",
  async (meeting: any) => {
    try {
      // TODO: Replace with real API call
      toast.error("Meeting update API not yet implemented", { autoClose: 3000 });
      throw new Error("Meeting update API not yet implemented");
    } catch (error) {
      toast.error("Meeting Update Failed", { autoClose: 3000 });
      return error;
    }
  }
);

export const deleteMeeting = createAsyncThunk(
  "meetings/deleteMeeting",
  async (meeting: any) => {
    try {
      // TODO: Replace with real API call
      toast.error("Meeting deletion API not yet implemented", { autoClose: 3000 });
      throw new Error("Meeting deletion API not yet implemented");
    } catch (error) {
      toast.error("Meeting Delete Failed", { autoClose: 3000 });
      return error;
    }
  }
);
